
/**
 * How the interval of a document requirement is read:
 *  - Calendar: n documents per calendar period
 *  - SinceLast: one document every n units, counted from the newest one
 */
export enum CdoIntervalMode {
  Calendar = 'calendar',
  SinceLast = 'since_last'
}
